import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from "@shopify/app-bridge-react";
const V1ProviderHack = ({ apiKey, host, router, children }) => {
    const config = {
        apiKey: apiKey,
        host: host,
        forceRedirect: true,
    };
    return (_jsx(Provider, { config: config, router: router, children: children }));
};
export default V1ProviderHack;
